// extracted by mini-css-extract-plugin
export default {"availabilityMainDiv":"Availability_availabilityMainDiv__TyXpp","bottom_part_availability":"Availability_bottom_part_availability__2X8q+"};